import React, { useCallback } from "react";

import Radio, { RadioChangeEvent } from "antd/es/radio";
import Space from "antd/es/space";
import { useIntl } from "react-intl";

import FilterType, { getFilterTypeDisplayName } from "./FilterType";

interface Props {
  className?: string;
  filterType: FilterType;
  onChangeFilterType: (filterType: FilterType) => void;
}

const FilterBar: React.FC<Props> = ({ className, filterType, onChangeFilterType }) => {
  const intl = useIntl();
  const handleFilterTypeChange = useCallback(
    (e: RadioChangeEvent) => onChangeFilterType(e.target.value as FilterType),
    [onChangeFilterType]
  );

  return (
    <section className={className}>
      <Space size="small">
        <Radio.Group buttonStyle="solid" onChange={handleFilterTypeChange} value={filterType}>
          <Radio.Button value={FilterType.ALL}>
            {getFilterTypeDisplayName(intl, FilterType.ALL)}
          </Radio.Button>
          <Radio.Button value={FilterType.FAVORITE}>
            {getFilterTypeDisplayName(intl, FilterType.FAVORITE)}
          </Radio.Button>
          <Radio.Button value={FilterType.DOWNLOADED}>
            {getFilterTypeDisplayName(intl, FilterType.DOWNLOADED)}
          </Radio.Button>
        </Radio.Group>
      </Space>
    </section>
  );
};

export default FilterBar;
